module.exports = __webpack_public_path__ + "img/daren_5.366e06d8.png";